import React, { useState } from "react";

interface DialectDropDownProps {
  selectedDialect: string;
  setSelectedDialect: React.Dispatch<React.SetStateAction<string>>;
  options: string[];
}

interface DialectDisplayProps {
  dialect: string;
}

// This subcomponent displays the selected dialect in green text
const DialectDisplay: React.FC<DialectDisplayProps> = ({ dialect }) => (
  <div style={{ color: "green", marginTop: "1em", fontWeight: "bold" }}>
    {dialect}
  </div>
);

const DialectDropdown: React.FC<DialectDropDownProps> = ({
  selectedDialect,
  setSelectedDialect,
  options,
}) => {
  return (
    <div dir="ltr">
      <label htmlFor="dialect-select">Choose a dialect: </label>
      <select
        id="dialect-select"
        value={selectedDialect}
        onChange={(e) => setSelectedDialect(e.target.value)}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <DialectDisplay dialect={selectedDialect} />
    </div>
  );
};

export default DialectDropdown;
